import React, {useEffect, useState} from 'react';
import PaymentCheckoutComponent from '../../../Components/UserComponents/PaymentCheckoutForm';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {
  getAttendesByUserAndEventId,
  readAddedRepsParent,
} from '../../../Store/Actions/eventRegister';
import {getAllChapters} from '../../../Store/Actions';

const PaymentCheckoutContainer = () => {
  const {id, attendeeType} = useParams();
  let dispatch = useDispatch();
  const [totalCartPrice, setTotalCartPrice] = useState(0);
  const [attendeesData, setAttendeesData] = useState([]);
  const [sponsorData, setSponsorData] = useState();
  const [localChapterId, setLocalChapterId] = useState([]);
  const [eventLocalChapterData, setEventLocalChapterData] = useState();
  const [appliedCartCoupon, setAppliedCartCoupon] = useState();
  const [eventType, setEventType] = useState('');
  const [eventISOnline, setEventISOnline] = useState(false);
  const [includeProcessingFee, setIncludeProcessingFee] = useState(true);
  const {allAttendees} = useSelector(({eventRegister}) => eventRegister);
  const allChapters = useSelector((state) => state.chapters.allChapters);
  const isSponsorCheckout = attendeeType === 'sponsor';

  useEffect(() => {
    if (!allChapters) {
      dispatch(getAllChapters());
    }
  }, []);

  useEffect(() => {
    if (!isSponsorCheckout) return;
    const parentSponsorId = readAddedRepsParent();
    if (!parentSponsorId) return;
    dispatch(
      getAttendesByUserAndEventId(
        id,
        attendeeType,
        includeProcessingFee,
        parentSponsorId,
      ),
    );
  }, [id, attendeeType, isSponsorCheckout]);

  useEffect(() => {
    if (allAttendees) {
      const registrations = allAttendees?.data?.event_registrations;
      const addedRepsParentId = isSponsorCheckout
        ? readAddedRepsParent()
        : undefined;
      const perkAttendees = registrations?.attendeesWithPerks;
      const plainAttendees = registrations?.attendees || [];
      // An empty perk list is truthy, so don't let it hide reps stored on attendees.
      const sourceAttendees = isSponsorCheckout
        ? perkAttendees?.length
          ? perkAttendees
          : plainAttendees
        : plainAttendees.filter((obj) => obj.is_reps === false);
      // A cart fetched for a different sponsorship (My Events → checkout) must not
      // replace this payment's reps with an empty filtered list.
      const attendees = addedRepsParentId
        ? sourceAttendees.filter(
            (attendee) =>
              attendee?.is_reps &&
              Number(attendee?.parent_sponsor_id) === addedRepsParentId,
          )
        : sourceAttendees;
      // A cart for another sponsorship, or an empty response that arrives
      // after the reps, must not clear the rows already on this checkout.
      if (addedRepsParentId && attendees.length === 0) {
        return;
      }
      const mappedAttendees = attendees.map((item) => ({
        ...item,
        food_option: item?.event_registration_options?.food,
        registration_option: item?.event_registration_options?.registration,
      }));
      setAttendeesData(mappedAttendees);
      setSponsorData(
        isSponsorCheckout && !addedRepsParentId
          ? registrations?.sponsor
          : undefined,
      );
      setLocalChapterId(allAttendees?.data?.local_chapter_id);
      setAppliedCartCoupon(
        addedRepsParentId ? undefined : allAttendees?.data?.discount_code,
      );
      setEventType(allAttendees?.data?.event_type_name);
      setEventISOnline(allAttendees?.data?.is_online);
      const addedRepsTotal = attendees.reduce(
        (sum, attendee) =>
          sum +
          Number(attendee?.total_cost || 0) -
          Number(attendee?.discount_amount || 0),
        0,
      );
      setTotalCartPrice(
        addedRepsParentId
          ? {
              total_price_per_cart: addedRepsTotal,
              discount: 0,
              discounted_price: addedRepsTotal,
              refund_credit: 0,
              refund_credit_for_regular_attendees: 0,
              processing_fee_amount: 0,
            }
          : {
              total_price_per_cart: allAttendees?.data?.total_price,
              discount: allAttendees?.data?.discount,
              discounted_price: allAttendees?.data?.discounted_price,
              refund_credit: allAttendees?.data?.refund_credit,
              refund_credit_for_regular_attendees:
                allAttendees?.data?.refund_credit,
              processing_fee_amount:
                allAttendees?.data?.processing_fee_amount || 0,
            },
      );
      const chapter = allChapters?.data?.chapters?.find(
        (obj) => obj.id === allAttendees?.data?.local_chapter_id,
      );
      setEventLocalChapterData(chapter);
    } else {
      getAttendeeByEventId(id, includeProcessingFee);
    }
  }, [allAttendees, includeProcessingFee, id, allChapters, isSponsorCheckout]);

  const getAttendeeByEventId = (eventId, includeFee = includeProcessingFee) => {
    dispatch(
      getAttendesByUserAndEventId(
        eventId,
        attendeeType,
        includeFee,
        isSponsorCheckout ? readAddedRepsParent() : undefined,
      ),
    );
  };

  return (
    <React.Fragment>
      <PaymentCheckoutComponent
        attendeesData={attendeesData}
        sponsorData={sponsorData}
        isSponsorCheckout={isSponsorCheckout}
        totalCartPrice={totalCartPrice}
        getAttendeeByEventId={(id) => {
          getAttendeeByEventId(id, includeProcessingFee);
        }}
        localChapterId={localChapterId}
        eventLocalChapterData={eventLocalChapterData}
        appliedCartCoupon={appliedCartCoupon}
        eventType={eventType}
        eventISOnline={eventISOnline}
        includeProcessingFee={includeProcessingFee}
        setIncludeProcessingFee={setIncludeProcessingFee}
      />
    </React.Fragment>
  );
};

export default PaymentCheckoutContainer;
